import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  attachments: {},
  addFiles: {},
  deleteFiles: [],
};

const attachmentsSlice = createSlice({
  name: "Attachments",
  initialState,
  reducers: {
    setAttachments: (state, action) => {
      const newAttachments = action.payload;

      Object.entries(newAttachments).forEach(([identifier, idMap]) => {
        if (!state.attachments[identifier]) {
          state.attachments[identifier] = {};
        }

        Object.entries(idMap).forEach(([id, data]) => {
          const newDocuments = data.documents || [];

          if (!state.attachments[identifier][id]) {
            state.attachments[identifier][id] = { documents: [] };
          }

          const existingDocs = state.attachments[identifier][id].documents;

          // Filter out duplicates by ID (preferred) or fileName fallback
          const uniqueDocs = newDocuments.filter(
            (doc) =>
              !existingDocs.some(
                (existing) =>
                  (doc.id && existing.id && doc.id === existing.id) ||
                  (!doc.id && doc.fileName === existing.fileName)
              )
          );

          state.attachments[identifier][id].documents.push(...uniqueDocs);
        });
      });
    },
    resetAttachmentByFormType: (state, action) => {
      const formTypeId = action.payload;
      const { [formTypeId]: _, ...rest } = state.attachments;
      state.attachments = rest;
    },
    resetAttachments: (state) => {
      state.attachments = {};
    },
    addFile: (state, action) => {
      const { fileName, base64, identifier } = action.payload;
      if (!state.addFiles[identifier]) {
        state.addFiles[identifier] = [];
      }
      state.addFiles[identifier].push({ fileName, FileBase64: base64 });
    },

    clearAddFiles: (state, action) => {
      const { identifier } = action.payload;
      delete state.addFiles[identifier];
    },

    removeStagedFile: (state, action) => {
      const { identifier, fileName } = action.payload;
      if (state.addFiles[identifier]) {
        state.addFiles[identifier] = state.addFiles[identifier].filter(
          (f) => f.fileName !== fileName
        );
      }
    },

    markFileForDeletion: (state, action) => {
      const { fileId } = action.payload;
      if (!state.deleteFiles.includes(fileId)) {
        state.deleteFiles.push(fileId);
      }
    },

    clearDeleteFiles: (state) => {
      state.deleteFiles = [];
    },
    removeExistingFile: (state, action) => {
      const { identifier, id, fileId } = action.payload;

      const docList = state.attachments?.[identifier]?.[id]?.documents;
      if (docList) {
        const fileToRemove = docList.find((doc) => doc.id === fileId);

        const baseGuidName = fileToRemove?.guidFileName?.replace(
          /\.jpg|\.png|\.jpeg|\.gif/i,
          ""
        );

        state.attachments[identifier][id].documents = docList.filter((doc) => {
          if (doc.id === fileId) return false;
          if (
            doc.isThumbnail &&
            doc.guidFileName?.startsWith(`${baseGuidName}_thumb`)
          ) {
            return false;
          }
          return true;
        });
      }
    },
  },
});

export const {
  setAttachments,
  addFile,
  clearAddFiles,
  removeStagedFile,
  markFileForDeletion,
  resetAttachmentByFormType,
  resetAttachments,
  clearDeleteFiles,
  removeExistingFile,
} = attachmentsSlice.actions;

export default attachmentsSlice.reducer;
